"use strict";
/// <reference types="jquery"/>
/// <reference types="jquery.form"/>
exports.__esModule = true;
exports.FormSubmitHandler = void 0;
require("jquery-form");
require("element-closest-polyfill");
require("classlist-polyfill");
require("child-replace-with-polyfill");
var FormSubmitHandler = /** @class */ (function () {
    function FormSubmitHandler() {
    }
    FormSubmitHandler.submit = function (form) {
        var formContainer = (form.dataset.container) ? form.closest(form.dataset.container) : form;
        var submitBtn = form.querySelector('input[type="submit"]');
        var resultContainer = formContainer.querySelector('.result__container');
        jQuery(form).ajaxSubmit({
            url: (form.dataset.action) ? form.dataset.action : form.getAttribute('action'),
            dataType: 'json',
            beforeSubmit: function (formData, $form, options) {
                return true;
            },
            error: function (error) {
                resultContainer.innerHtml('Ошибка! Обратитесь к администратору');
            },
            success: function (responseText, statusText, xhr) {
                if (responseText.status) {
                    resultContainer.innerHtml(responseText.message);
                }
                else {
                    var div = document.createElement('div');
                    div.classList.add('text-center');
                    div.innerHTML = responseText.message;
                    formContainer.replaceWith(div);
                    if (jQuery.fn.fancybox && form.classList.contains('fancybox-modal-form')) {
                        jQuery.fancybox.update();
                    }
                }
            }
        });
    };
    return FormSubmitHandler;
}());
exports.FormSubmitHandler = FormSubmitHandler;
